/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
    DirectionToJSONTyped,
} from './Direction';

/**
 * Minimum information about a flight
 * @export
 * @interface CompactFlight
 */
export interface CompactFlight {
    /**
     * 
     * @type {Direction}
     * @memberof CompactFlight
     */
    direction: Direction;
    /**
     * Departure airport code before cruise
     * @type {string}
     * @memberof CompactFlight
     */
    depAirportCode?: string;
    /**
     * Arrival airport code after cruise
     * @type {string}
     * @memberof CompactFlight
     */
    arrAirportCode?: string;
}



/**
 * Check if a given object implements the CompactFlight interface.
 */
export function instanceOfCompactFlight(value: object): value is CompactFlight {
    if (!('direction' in value) || value['direction'] === undefined) return false;
    return true;
}

export function CompactFlightFromJSON(json: any): CompactFlight {
    return CompactFlightFromJSONTyped(json, false);
}

export function CompactFlightFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompactFlight {
    if (json == null) {
        return json;
    }
    return {
        
        'direction': DirectionFromJSON(json['direction']),
        'depAirportCode': json['depAirportCode'] == null ? undefined : json['depAirportCode'],
        'arrAirportCode': json['arrAirportCode'] == null ? undefined : json['arrAirportCode'],
    };
}

export function CompactFlightToJSON(json: any): CompactFlight {
    return CompactFlightToJSONTyped(json, false);
}

export function CompactFlightToJSONTyped(value?: CompactFlight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'direction': DirectionToJSON(value['direction']),
        'depAirportCode': value['depAirportCode'],
        'arrAirportCode': value['arrAirportCode'],
    };
}

